<template>
  <div :class="type" class="app-footer">
    <div class="app-footer-content">
      <div class="social-list">
        <div class="social-item" v-for="item in state.socialList" :key="item.name" v-show="item.url">
          <a :href="item.url" target="_blank">
            <img :src="item.img" alt="social">
          </a>
        </div>
      </div>
      <div class="link-list">
        <div class="link-item" v-for="item in state.linkList" :key="item.name">
          <a :href="item.url" target="_blank">
            {{ item.name }}
          </a>
        </div>
      </div>
      <div class="footer-text">
        {{ $t('footer.text') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { reactive, computed } from 'vue'
const type = isMobile ? 'mobile' : 'pc'
import fbIcon from '@/assets/imgs/icon-fb.png'
import fbGroupIcon from '@/assets/imgs/icon-fb-group.png'
import dcIcon from '@/assets/imgs/icon-dc.png'
import ytIcon from '@/assets/imgs/icon-yt.png'
import ttIcon from '@/assets/imgs/icon-tt.png'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const state = reactive({
  socialList: [
    {
      name: 'fb',
      url: computed(() => t('footer.jumpLink.fb')),
      img: fbIcon
    },
    {
      name: 'fb-group',
      url: computed(() => t('footer.jumpLink.fbGroup')),
      img: fbGroupIcon
    },
    {
      name: 'dc',
      url: computed(() => t('footer.jumpLink.dc')),
      img: dcIcon
    },
    {
      name: 'yt',
      url: computed(() => t('footer.jumpLink.yt')),
      img: ytIcon
    },
    {
      name: 'tt',
      url: computed(() => t('footer.jumpLink.tt')),
      img: ttIcon
    },
  ],
  linkList: [
    {
      name: computed(() => t('footer.link.security')),
      url: computed(() => t('footer.jumpLink.security'))
    },
    {
      name: computed(() => t('footer.link.privacy')),
      url: computed(() => t('footer.jumpLink.privacy'))
    }
  ]
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
